import React, { useRouter } from 'next/router';

import Post from '@components/changelog/Post';
import CTA from '@components/CTA';
import CustomHead from '@components/CustomHead';
import Footer from '@components/FooterNew';
import Header from '@components/HeaderNew';
import { SectionContainer } from '@components/landing/sectionComponents';
import { revalidate } from '@utils/constants';
import { getChangelogPosts } from '@utils/contentfulClient';

function Updates({ post }) {
  const router = useRouter();

  const metaTitle =
    post.fields.title || `${post.fields.slug} - Changelog - PopSQL`;
  const metaDescription = post.fields.snippet || 'PopSQL Changelog';
  return (
    <>
      <CustomHead
        meta={{
          title: metaTitle,
          description: metaDescription,
          ...(post.coverImage
            ? {
                image: `${process.env.NEXT_PUBLIC_ASSET_HOST}${post.fields.coverImage.fields.file.url}`,
              }
            : {}),
        }}
        openGraph={{
          title: metaTitle,
          description: metaDescription,
          url: `${process.env.NEXT_PUBLIC_WEB_HOST}${router.asPath}`,
        }}
      />
      <main>
        <Header />
        <SectionContainer styles={{ paddingTop: '86px', paddingBottom: '0' }}>
          <Post headingTag="h1" headingSize="lg" post={post.fields} />
        </SectionContainer>
        <CTA />
      </main>
      <Footer />
    </>
  );
}

export async function getStaticPaths() {
  const posts = await getChangelogPosts();
  const ret = {
    paths: posts.map((post) => ({ params: { slug: post.fields.slug } })),
    fallback: 'blocking',
  };
  return ret;
}

export async function getStaticProps(ctx) {
  try {
    const { slug } = ctx.params;
    const posts = await getChangelogPosts();
    const post = posts.find((p) => p.fields.slug === slug);
    return {
      props: {
        post,
      },
      revalidate,
    };
  } catch (error) {
    console.error(error);
    return {
      props: {
        pages: null,
        pageNum: null,
        err: 'Something went wrong 😕',
      },
    };
  }
}

export default Updates;
